import { WebStorageStateStore } from "oidc-client-ts";
import type { AuthProviderProps } from "react-oidc-context";
import { OidcSettings } from "../swagger-clients/s365-dashboard-v2-web-clients.service";

/**
 * Base URL of the Authentik identity provider.
 * Populated at startup from the /api/settings endpoint.
 */
export let AUTHENTIK_BASE_URL = "";

let _oidcAuthority = "";
let _oidcClientId = "";
let _dashboardServiceUrl = "";

/**
 * Mutable OIDC config initialised by initOidcConfig() before React mounts.
 */
export let oidcConfig: AuthProviderProps = {};

/**
 * Initialise the OIDC configuration from settings loaded from the backend.
 * Must be called before the React tree is rendered.
 */
export function initOidcConfig(oidcSettings: OidcSettings, dashboardServiceUrl: string) {
AUTHENTIK_BASE_URL = oidcSettings.authentikBaseUrl ?? "";
_oidcAuthority = oidcSettings.oidcAuthority ?? "";
_oidcClientId = oidcSettings.oidcClientId ?? "";
_dashboardServiceUrl = dashboardServiceUrl;
const dashboardServiceSlug = oidcSettings.dashboardServiceSlug ?? "dashboard-service";

const oidcMetadata = {
    issuer: _oidcAuthority,
    authorization_endpoint: `${AUTHENTIK_BASE_URL}/application/o/authorize/`,
    token_endpoint: _dashboardServiceUrl + "/api/oidc-proxy/token",
    userinfo_endpoint: `${AUTHENTIK_BASE_URL}/application/o/userinfo/`,
    end_session_endpoint: `${AUTHENTIK_BASE_URL}/application/o/${dashboardServiceSlug}/end-session/`,
    revocation_endpoint: _dashboardServiceUrl + "/api/oidc-proxy/revoke",
    jwks_uri: `${AUTHENTIK_BASE_URL}/application/o/${dashboardServiceSlug}/jwks/`,
};

    oidcConfig = {
        authority: _oidcAuthority,
        client_id: _oidcClientId,
        redirect_uri: window.location.origin + "/",
        post_logout_redirect_uri: window.location.origin + "/",
        scope: "email offline_access openid profile authentik_pk",
        response_type: "code",
        automaticSilentRenew: true,
        userStore: new WebStorageStateStore({ store: window.localStorage }),
        metadata: oidcMetadata,
        onSigninCallback: () => {
            window.history.replaceState({}, document.title, window.location.pathname);
        },
    };
}

/**
 * Storage key used to read the OIDC user from localStorage.
 */
export const getOidcStorageKey = () => `oidc.user:${_oidcAuthority}:${_oidcClientId}`;

/**
 * @deprecated Use getOidcStorageKey() instead.
 */
export const OIDC_STORAGE_KEY = `oidc.user:${_oidcAuthority}:${_oidcClientId}`;
